export default __webpack_public_path__ + "static/media/checkout.3aa2680a.svg";